import React from 'react';
import ReactDOM from 'react-dom';

import { Time } from './index';

const createDateEl = (props, el) => (
    ReactDOM.createPortal(<Time { ...props }/>, el)
);

export const renderDateEl = (props, el) => {
    ReactDOM.render(
        <>{createDateEl(props, el)}</>,
        document.createElement('div')
    );
};
